import { Box } from "@mui/material"
import type { FC } from "react"

import { ProductTestComments } from "./ProductTestComments"
import { ProductTestResultsTable } from "./ProductTestResultsTable"

import type { ProductTest, ProductTestResult } from "@/graphql/codegen/graphql"

interface Props {
  productTest: ProductTest
  onOverride: (productTestResult: ProductTestResult) => void
}

export const ProductTestExpandedContent: FC<Props> = ({ productTest, onOverride }) => (
  <Box className='flex flex-col gap-6 p-6' data-test='row-expanded-content'>
    <ProductTestResultsTable productTest={productTest} onOverride={onOverride} />
    <ProductTestComments productTest={productTest} />
  </Box>
)
